/**
 * Strip Vue reactivity / observers so lodash (Chart.js) deep-clone stays bounded.
 */
export function toPlainObject(value) {
  if (value == null) return value
  if (typeof value !== 'object') return value
  try {
    return JSON.parse(JSON.stringify(value))
  } catch (e) {
    if (Array.isArray(value)) return value.slice()
    return { ...value }
  }
}
